/**
 * 契約サービス分類ID
 */
export const CONTRACT_SERVICE_CLASS_ID = {
  /** 月額契約 */
  MONTHLY_CONTRACT: "BLC-000010",
  /** 整備・鈑金・車販  */
  SF_REPAIR_CARSALES: "BLC-100100",
  /** 電帳 */
  ELECTRONIC_DOCUMENT: "BLC-100400",
}